<template functional>
    <div class="grid-fitted align-items-center">
        <div class="grid-item weight-bar">
            <div class="item-weight" :style="`width:${props.relativeWeight}%`"></div>
        </div>
        <div class="grid-item no-flex text-right padding-left-s weight-value">
            <span class="is-numeric">{{props.relativeWeight}}%</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'item-weight-bar',
        props: {
            relativeWeight: {
                type: [String, Number],
                default: '0',
            },
        },
    };
</script>

<style scoped>
    .weight-bar {
        height: 14px;
        background-color: #eeeeee;
        padding: 4px;
        border-radius: 6px;
        box-shadow: inset 0 0 2px 1px rgba(0, 0, 0, 0.1);
    }

    .weight-value {
        width: 35px;
    }

    .item-weight {
        height: 100%;
        background: #ed5151;
        border-radius: 4px;
        background: linear-gradient(to right, #3498db 0%, #6eb32e 35%, #edd951 70%, #ed5151 100%) no-repeat;
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#3498db', endColorstr='#ed5151', GradientType=1);
        background-size: auto;
        transition: 0.15s ease-out;
        transition-property: opacity background;
    }
</style>
